var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgColouredGold({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1.4vw",
    height: "1.4vw",
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    rx: 14,
    fill: "#262626"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.2064 15.3397L12.206 15.3393L12.2039 15.338L12.2064 15.3397ZM20 13.9628L19.0956 11.4081L15.8084 9.5L8.99618 13.377L8 16.2187L12.0158 18.5L12.0818 15.408L8.95766 13.5034L9.22565 13.6548L9.0728 13.5607L9.61863 13.8705L9.12198 13.5607L12.206 15.3393L18.8465 11.6745L17.7835 12.2976L19.028 11.619L16.5648 13.0116L12.2892 15.5174L12.0154 18.4996L19.9996 13.9619L20 13.9628ZM12.3392 14.4476L10.5406 13.4229L12.29 14.0004L17.6458 11.4628L12.3392 14.4476Z",
    fill: "#FFD700"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgColouredGold);
export default __webpack_public_path__ + "static/media/coloured_gold.857b2f609ed2732fa9749644b15383d2.svg";
export { ForwardRef as ReactComponent };